export enum MODEL_FAMILIES {
  LLAMA_3_2 = 'llama_3.2',
  GEMMA_3 = 'gemma_3',
  QWEN_3VL = 'qwen_3vl',
  QWEN_3_5 = 'qwen_3.5',
  GLM_4_6V = 'glm_4.6v',
  MINISTRAL_3 = 'ministral_3',
  GEMMA_4 = 'gemma_4',
}
